import { Component, OnInit, OnDestroy } from '@angular/core';
import { sweetAlert } from '../../../utils/swal';
import { takeUntil } from 'rxjs/operators';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import { StaffService } from '../../staffs/staff-service/staff.service';
import { ServiceZoneService } from '../service-zone-service/service-zone.service';

@Component({
  selector: 'app-service-zone-listing',
  templateUrl: './service-zone-listing.component.html',
  styleUrls: ['./service-zone-listing.component.css']
})
export class ServiceZoneListingComponent implements OnInit {
  search;
  selectedStatus: any = "active";
  cityZones = [];

  constructor(
       private serviceZone: ServiceZoneService) {
  }

  ngOnInit() {
    this.getServiceAreas()
  }

  getServiceAreas(){
    this.serviceZone.getServiceZone({status: this.selectedStatus})
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(
        (data) => {
          if (data) {
            this.cityZones = data
          }
        },
        (err) => {
          sweetAlert("Error", err, "error", "Ok");
        }
      );
    }


  ngOnDestroy(): void {
  }

  onChangeStatus() {
    this.getServiceAreas();
  }

}
